import validateAddress from 'utils/addresses/validators/validateAddress';

export default {
  validateAddress,
};
